import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'
import { VendorContact } from './types'

export interface CreateVendorContactsResponse extends Response {
	data: {
		inserted_items: VendorContact[]
	}
}

export type CreateVendorContactsPayload = {
	name: string
	position: string
	email: string
	phone: string
}[]

export const createVendorContacts = async (
	vendorContacts: CreateVendorContactsPayload,
): Promise<CreateVendorContactsResponse> => {
	const response = await client.post<CreateVendorContactsResponse>(
		'vendors/contacts',
		vendorContacts,
	)

	return response.data
}
